import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.form `
  position: relative;
  width: 100%;
  max-width: 576px;
  margin: 0 auto;
`;
const InputWrapper = styled.div `
  position: relative;
  z-index: 2;
`;
const Input = styled.input `
  ${transition('border-color')}

  display: block;
  appearance: none;
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  color: ${brand.primary.blue};
  ${fonts.apparat.light}
  font-size: 18px;
  height: 50px;
  line-height: 1em;
  padding: 0 24px;
  width: 100%;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }

  &:focus {
    border-color: ${brand.primary.blue};
  }
`;
const Button = styled.button `
  ${transition('background-color, border-color, color')}

  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: inline-flex;
  align-items: center;
  background-color: ${brand.white};
  border: 2px solid ${brand.primary.blue};
  border-radius: 25px;
  color: ${brand.primary.blue};
  gap: 8px;
  padding: 0px ${fluid(20, 32)};

  ${Input}:focus + &,
  &:focus,
  &:hover {
    background-color: ${brand.primary.blue};
    border-color: ${brand.primary.blue};
    color: ${brand.white};
  }
`;
const ButtonIcon = styled.span `
  display: inline-block;
  height: 19px;
  transform: translateX(4px);
  width: 19px;

  ${Input}:focus + ${Button} &,
  ${Button}:focus &,
  ${Button}:hover & {
    transform: translateX(0px);
  }
`;
const ButtonLabel = styled.span `
  ${transition('width')}

  display: inline-block;
  color: currentColor;
  ${fonts.apparat.bold};
  font-size: 16px;
  line-height: 1em;
  overflow: hidden;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  width: 0px;

  ${Input}:focus + ${Button} &,
  ${Button}:focus &,
  ${Button}:hover & {
    width: 8ch;
  }
`;
const SearchStyles = {
    Button,
    ButtonIcon,
    ButtonLabel,
    Container,
    Input,
    InputWrapper,
};
export default SearchStyles;
